import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from './components/header';
import Footer from './components/footer';
import SEOTags from './common/SEO';
import Logo from './assets/img/NGF-logo.svg';
import AboutImg from './assets/img/common/about-img.jpg'
import AboutBanner from './assets/img/banner/AboutUsBanner.jpg';


const About = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const loadVideo = () => {
        setVideoLoaded(true);
    };
    useEffect(() => {
        SEOTags(
            "About | Figgers Law"
        );
    }, [])
    return (
        <>

            <Header></Header>
            <div className="about-page-hero" style={{
                backgroundImage: `url(${AboutBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "right",
            }}
            >
                <div className="container">
                    <div className="section-label">About Us</div>
                    <h1>The Law Office of Natlie G. Figgers, <br></br>PLLC
d/b/a Figgers Law
</h1>
                    <p>
                      A Florida business law, commercial litigation, and personal injury firm advising clients on business formation, corporate governance, contracts, contract management, and commercial disputes, and representing individuals harmed by commercial vehicles, unsafe premises, negligent security, and other forms of corporate negligence.
                    </p>
                </div>
            </div>

            <section className="about" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div
                            className="about-image-wrap"
                            style={{ position: "relative" }}
                        >
                            <div className="about-attorney-image">
                                <img
                                    src={AboutImg}
                                    alt="Natlie G. Figgers, Esq."
                                />
                            </div>

                            <div className="about-badge">
                                <img
                                    className="about-badge-logo"
                                    src={Logo}
                                    alt="Figgers Law Logo"
                                />

                                <div className="gold-divider"></div>

                                <small>Attorney &amp; Founder</small>
                            </div>
                        </div>

                        <div className="about-content">
                            <div className="section-label">Meet the Founder & Managing Attorney</div>

                            <h2>Natlie G. Figgers, Esq.</h2>

                            <h3>
                                Founder and Managing Attorney

                            </h3>

                            <p><Link to='/contact-us' class="btn-gold" data-discover="true" style={{ margin: '7px 0px' }}> Schedule a Confidential Consultation</Link></p>

                            <p>
                                Natlie G. Figgers is a nationally recognized Florida attorney whose practice brings together business counsel, complex litigation, and serious personal injury representation.


                            </p>

                            <p>
                                As the founder and managing attorney of Figgers Law, Natlie advises entrepreneurs, established businesses, executives, and organizations throughout the life cycle of a business, from formation and corporate governance to contract negotiation, contract management, risk assessment, and commercial disputes. Her experience includes negotiating, drafting, and managing sophisticated commercial agreements valued at more than $75 million.


                            </p>


                        </div>
                    </div>
                </div>

                <div className="container about-content" style={{ marginTop: '44px' }}>
                    <p>
                        Natlie also represents individuals and families in serious injury matters
                        involving commercial and institutional defendants. Her injury practice
                        focuses on cases involving commercial trucks, fleet and company vehicles,
                        unsafe business premises, negligent security, defective products, and
                        other forms of corporate negligence. This focused approach allows the firm
                        to investigate not only the immediate incident, but also the corporate
                        policies, operational failures, contractual relationships, and safety
                        practices that may have contributed to the harm.
                    </p>

                    <p>
                        Before and alongside her legal practice, Natlie developed more than 13
                        years of experience in human resources leadership, corporate operations,
                        compliance, and organizational management. That background gives her a
                        practical understanding of how legal decisions affect a company’s
                        employees, contracts, finances, operations, and long-term growth.
                    </p>

                    <p>
                        Natlie earned her Juris Doctor from Nova Southeastern University and her
                        Bachelor of Science in Criminal Justice, cum laude, from Florida A&amp;M
                        University. She is admitted to practice throughout Florida, before the
                        United States District Court for the Southern District of Florida, and
                        before the United States Court of Appeals for the Eleventh Circuit. She is
                        fluent in English and Haitian Kreyol.
                    </p>

                    <p>Recognition and Professional Distinctions</p>

                    <ul className="about-list">
                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Founder and Managing Attorney of Figgers Law
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            The National Black Lawyers Top 40 Under 40 — 2020 and 2021
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Top 100 Attorneys — 2020
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Appointed to the Florida A&amp;M University Board of Trustees
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Florida Memorial University Most Ardent Community Advocate Award — 2022
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Circle of Brotherhood Power of Leadership Award — 2026
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Advocate in the effort that contributed to the exoneration of Thomas
                            Raynard James after 32 years of wrongful incarceration
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Experience negotiating, drafting, and managing commercial agreements
                            valued at more than $75 million
                        </li>

                        <li>
                            <svg
                                width="18"
                                height="18"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            Admitted to The Florida Bar, the Southern District of Florida, and the
                            Eleventh Circuit Court of Appeals
                        </li>
                    </ul>
                </div>
            </section>
            <Footer></Footer>
        </>

    );
};

export default About;
